import b_ from "b_";
// extracted by mini-css-extract-plugin
export default {"textInput":"styles_textInput__zTP-0","input":"styles_input__RIpd7","textarea":"styles_textarea__9auC4","mock":"styles_mock__QjWKL","hidden":"styles_hidden__jtuGq"};
export const b = b_.with('textInput');